import { useParams } from 'react-router-dom';

import { useMutationOverwriteTemplateFromReport } from 'api/mutations/OverwriteTemplateFromReport.mutation';
import { useMutationCreateTemplateFromReport } from 'api/mutations/createNewTemplateFromReport.mutation';
import { useQueryGetReport } from 'api/queries/getReport.query';
import { useQueryGetReportTemplateList } from 'api/queries/getReportTemplateList.query';

import { ReportPageUrlParams } from 'components/pages/ReportPage/ReportPage';

export type UseCreateTemplateFromReportModalProvider = ReturnType<typeof useCreateTemplateFromReportModalProvider>;

export const useCreateTemplateFromReportModalProvider = () => {
    const reportId = Number(useParams<ReportPageUrlParams>().reportId);
    const getReport = useQueryGetReport({ id: reportId });
    const getReportTemplates = useQueryGetReportTemplateList({
        filter: {
            filters: [],
        },
    });

    const createTemplateFromReport = {
        instance: useMutationCreateTemplateFromReport(),
    };
    const overwriteTemplateFromReport = {
        instance: useMutationOverwriteTemplateFromReport(),
    };

    return {
        api: {
            getReport,
            getReportTemplates,
            createTemplateFromReport,
            overwriteTemplateFromReport,
        },
    };
};
